import { Fraction } from 'bi-fraction';
import { LP_FEE_RATIO_MAP } from '../config/fee';
export const getTradeExtraInfo = (trade, slippageTolerance) => {
    let lpFeeRatio = new Fraction(0);
    let expectedOutputAmount = new Fraction(0);
    trade.routes.forEach((r) => {
        let remain = new Fraction(1);
        let price = new Fraction(1);
        r.pool.forEach((p) => {
            remain = remain.mul(new Fraction(1).sub(LP_FEE_RATIO_MAP[p.version]));
            price = price.mul(p.price);
        });
        lpFeeRatio = new Fraction(1).sub(remain).mul(r.percentage).add(lpFeeRatio);
        expectedOutputAmount = expectedOutputAmount.add(new Fraction(r.amountIn.amount).shr(r.amountIn.decimals).mul(price));
    });
    const priceImpact = expectedOutputAmount
        .sub(new Fraction(trade.amountOut.amount).shr(trade.amountOut.decimals))
        .div(expectedOutputAmount);
    return {
        lpFeeRatio: +lpFeeRatio.toFixed(PERCENTAGE_PRECISION), // trading fee ratio
        lpFee: {
            ...trade.amountIn,
            amount: lpFeeRatio.mul(trade.amountIn.amount).toFixed(0), // trim decimal
        }, // trading fee
        priceImpact: +priceImpact.toFixed(PERCENTAGE_PRECISION),
        priceImpactExcludeLpFee: +priceImpact
            .sub(lpFeeRatio)
            .toFixed(PERCENTAGE_PRECISION), // price impact exclude trading fee
        gasEstimate: trade.gasEstimate, // gas estimate in native token = gasEstimate * gasPrice
        gasRefundMin: 0.3,
        gasRefundMax: 0.9,
        receivedMin: {
            ...trade.amountOut,
            amount: new Fraction(1)
                .sub(slippageTolerance)
                .mul(trade.amountOut.amount)
                .toFixed(0), // trim decimal
        },
        receivedMax: {
            ...trade.amountOut,
            amount: new Fraction(1)
                .add(slippageTolerance)
                .mul(trade.amountOut.amount)
                .toFixed(0), // trim decimal
        },
        disableSwap: priceImpact.gte(0.15), // block swap if price impact >= 15%
    };
};
const PERCENTAGE_PRECISION = 8;
